export function buildJobLabelledOptions(options: any[]) {
  return options.map((opt) => {
    return {
      label: `${opt.name} (${opt.department || 'no department'})`,
      value: opt.id,
    };
  });
}
